import React from "react";
import { ArrowUpRight, Calendar } from "lucide-react";
import { useNavigate } from "react-router-dom";

const events = [
  {
    number: "01",
    title: "Atelier citoyen : Comment améliorer votre quartier",
    date: "15 octobre 2024",
    location: "Centre culturel municipal",
    type: "Atelier"
  },
  {
    number: "02",
    title: "Hackathon des services publics",
    date: "22-23 novembre 2024",
    location: "Espace numérique",
    type: "Événement"
  }
];

const EventsSection = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="max-w-2xl mb-16 md:mb-24">
        <span className="ed-eyebrow mb-5 block">05 — Agenda</span>
        <h2 className="ed-heading text-3xl md:text-5xl mb-5">
          Événements <span className="accent">à venir</span>
        </h2>
        <p className="ed-subtle text-base md:text-lg leading-relaxed max-w-lg">
          Rencontrez la communauté lors d'ateliers, conférences et rendez-vous citoyens.
        </p>
      </div>

      {/* Timeline — editorial single column */}
      <div className="relative">
        {/* Central spine */}
        <div className="absolute left-[27px] md:left-[31px] top-2 bottom-2 w-px bg-gradient-to-b from-[var(--ed-navy-500)] via-[var(--ed-rule)] to-transparent opacity-40" />

        <div className="space-y-16 md:space-y-20">
          {events.map((event, idx) => (
            <div
              key={event.number}
              className="relative flex gap-6 md:gap-10 group ed-fade-up"
              style={{ animationDelay: `${idx * 120}ms` }}
            >
              {/* Step marker */}
              <div className="relative z-10 shrink-0">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-[var(--ed-paper)] border border-[var(--ed-rule-strong)] flex items-center justify-center shadow-sm group-hover:border-[var(--ed-navy-500)] group-hover:shadow-md transition-all duration-500">
                  <span className="ed-numeric text-xl md:text-2xl text-[var(--ed-navy-800)]">
                    {event.number}
                  </span>
                </div>
              </div>

              {/* Content card */}
              <div className="pt-1 md:pt-2 flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 rounded-full bg-[var(--ed-navy-800)]/5 flex items-center justify-center">
                    <Calendar
                      size={16}
                      strokeWidth={1.5}
                      className="text-[var(--ed-navy-500)]"
                    />
                  </div>
                  <span className="font-display text-[10px] uppercase tracking-[0.28em] text-[var(--ed-navy-500)]">
                    {event.type}
                  </span>
                </div>

                <h3 className="font-display font-semibold text-lg md:text-xl text-[var(--ed-ink)] tracking-tight mb-3">
                  {event.title}
                </h3>

                <p className="text-[rgba(10,15,31,0.60)] text-sm md:text-base leading-[1.7] font-light max-w-md mb-5">
                  {event.date} · {event.location}
                </p>

                <div className="ed-rule mb-5" />

                <button
                  onClick={() => navigate("/collaborative-space")}
                  className="inline-flex items-center gap-2 font-display font-semibold text-sm text-[var(--ed-navy-800)] group-hover:gap-3 transition-all"
                >
                  S'inscrire <ArrowUpRight className="h-4 w-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Editorial CTA */}
      <div className="mt-16 md:mt-24 flex items-center gap-6">
        <div className="h-px w-16 bg-[var(--ed-navy-500)]" />
        <span className="text-xs text-[rgba(10,15,31,0.40)] font-body tracking-wide">
          Ateliers gratuits · Ouverts à tous · Places limitées
        </span>
      </div>
    </div>
  );
};

export default EventsSection;
